export const SocialActionTypes = {
    CREATE_LIVESTREAM_REQUEST: "@@Social/CREATE_LIVESTREAM_REQUEST",
    CREATE_LIVESTREAM_SUCCESS: "@@Social/CREATE_LIVESTREAM_SUCCESS",
    CREATE_LIVESTREAM_FAILURE: "@@Social/CREATE_LIVESTREAM_FAILURE",

    TOP_RECOMMENDED_HOMELIVESTREAM_REQUEST:
        "@@Social/TOP_RECOMMENDED_HOMELIVESTREAM_REQUEST",
    TOP_RECOMMENDED_HOMELIVESTREAM_SUCCESS:
        "@@Social/TOP_RECOMMENDED_HOMELIVESTREAM_SUCCESS",
    TOP_RECOMMENDED_HOMELIVESTREAM_FAILURE:
        "@@Social/TOP_RECOMMENDED_HOMELIVESTREAM_FAILURE",

    TOP_RECOMMENDED_LIVESTREAM_REQUEST:
        "@@Social/TOP_RECOMMENDED_LIVESTREAM_REQUEST",
    TOP_RECOMMENDED_LIVESTREAM_SUCCESS:
        "@@Social/TOP_RECOMMENDED_LIVESTREAM_SUCCESS",
    TOP_RECOMMENDED_LIVESTREAM_FAILURE:
        "@@Social/TOP_RECOMMENDED_LIVESTREAM_FAILURE",

    RECENT_LIVESTREAM_REQUEST: "@@Social/RECENT_LIVESTREAM_REQUEST",
    RECENT_LIVESTREAM_SUCCESS: "@@Social/RECENT_LIVESTREAM_SUCCESS",
    RECENT_LIVESTREAM_FAILURE: "@@Social/RECENT_LIVESTREAM_FAILURE",

    JUST_LIVESTREAM_REQUEST: "@@Social/JUST_LIVESTREAM_REQUEST",
    JUST_LIVESTREAM_SUCCESS: "@@Social/JUST_LIVESTREAM_SUCCESS",
    JUST_LIVESTREAM_FAILURE: "@@Social/JUST_LIVESTREAM_FAILURE",

    SEARCH_LIVESTREAM_REQUEST: "@@Social/SEARCH_LIVESTREAM_REQUEST",
    SEARCH_LIVESTREAM_SUCCESS: "@@Social/SEARCH_LIVESTREAM_SUCCESS",
    SEARCH_LIVESTREAM_FAILURE: "@@Social/SEARCH_LIVESTREAM_FAILURE",

    FOLLOWING_LIVESTREAM_REQUEST: "@@Social/FOLLOWING_LIVESTREAM_REQUEST",
    FOLLOWING_LIVESTREAM_SUCCESS: "@@Social/FOLLOWING_LIVESTREAM_SUCCESS",
    FOLLOWING_LIVESTREAM_FAILURE: "@@Social/FOLLOWING_LIVESTREAM_FAILURE",

    FETCH_LIVESTREAM_ID_REQUEST: "@@Social/FETCH_LIVESTREAM_ID_REQUEST",
    FETCH_LIVESTREAM_ID_SUCCESS: "@@Social/FETCH_LIVESTREAM_ID_SUCCESS",
    FETCH_LIVESTREAM_ID_FAILURE: "@@Social/FETCH_LIVESTREAM_ID_FAILURE",

    FETCH_LIVESTREAM_REQUEST: "@@Social/FETCH_LIVESTREAM_REQUEST",
    FETCH_LIVESTREAM_SUCCESS: "@@Social/FETCH_LIVESTREAM_SUCCESS",
    FETCH_LIVESTREAM_FAILURE: "@@Social/FETCH_LIVESTREAM_FAILURE",

    FETCH_BOOKMARK_REQUEST: "@@Social/FETCH_BOOKMARK_REQUEST",
    FETCH_BOOKMARK_SUCCESS: "@@Social/FETCH_BOOKMARK_SUCCESS",
    FETCH_BOOKMARK_FAILURE: "@@Social/FETCH_BOOKMARK_FAILURE",

    CREATE_BOOKMARK_REQUEST: "@@Social/CREATE_BOOKMARK_REQUEST",
    CREATE_BOOKMARK_SUCCESS: "@@Social/CREATE_BOOKMARK_SUCCESS",
    CREATE_BOOKMARK_FAILURE: "@@Social/CREATE_BOOKMARK_FAILURE",

    DELETE_BOOKMARK_REQUEST: "@@Social/DELETE_BOOKMARK_REQUEST",
    DELETE_BOOKMARK_SUCCESS: "@@Social/DELETE_BOOKMARK_SUCCESS",
    DELETE_BOOKMARK_FAILURE: "@@Social/DELETE_BOOKMARK_FAILURE",

    CREATE_WOWZA_REQUEST: "@@Social/CREATE_WOWZA_REQUEST",
    CREATE_WOWZA_SUCCESS: "@@Social/CREATE_WOWZA_SUCCESS",
    CREATE_WOWZA_FAILURE: "@@Social/CREATE_WOWZA_FAILURE",

    FETCH_EVENT_REQUEST: "@@Social/FETCH_EVENT_REQUEST",
    FETCH_EVENT_SUCCESS: "@@Social/FETCH_EVENT_SUCCESS",
    FETCH_EVENT_FAILURE: "@@Social/FETCH_EVENT_FAILURE",
    UPDATE_EVENT_INTERNAL: "@@Social/UPDATE_EVENT_INTERNAL",

    FETCH_REACTION_REQUEST: "@@Social/FETCH_REACTION_REQUEST",
    FETCH_REACTION_SUCCESS: "@@Social/FETCH_REACTION_SUCCESS",
    FETCH_REACTION_FAILURE: "@@Social/FETCH_REACTION_FAILURE",

    DELETE_LIVESTREAM_REQUEST: "@@Social/DELETE_LIVESTREAM_REQUEST",
    DELETE_LIVESTREAM_SUCCESS: "@@Social/DELETE_LIVESTREAM_SUCCESS",
    DELETE_LIVESTREAM_FAILURE: "@@Social/DELETE_LIVESTREAM_FAILURE",

    UPDATE_LIVESTREAM_REQUEST: "@@Social/UPDATE_LIVESTREAM_REQUEST",
    UPDATE_LIVESTREAM_SUCCESS: "@@Social/UPDATE_LIVESTREAM_SUCCESS",
    UPDATE_LIVESTREAM_FAILURE: "@@Social/UPDATE_LIVESTREAM_FAILURE",

    CLONE_LIVESTREAM_REQUEST: "@@Social/CLONE_LIVESTREAM_REQUEST",
    CLONE_LIVESTREAM_SUCCESS: "@@Social/CLONE_LIVESTREAM_SUCCESS",
    CLONE_LIVESTREAM_FAILURE: "@@Social/CLONE_LIVESTREAM_FAILURE",

    UPDATE_LIVESTREAM_PRODUCT_REQUEST:
        "@@Social/UPDATE_LIVESTREAM_PRODUCT_REQUEST",
    UPDATE_LIVESTREAM_PRODUCT_SUCCESS:
        "@@Social/UPDATE_LIVESTREAM_PRODUCT_SUCCESS",
    UPDATE_LIVESTREAM_PRODUCT_FAILURE:
        "@@Social/UPDATE_LIVESTREAM_PRODUCT_FAILURE",

    UPDATE_LIVESTREAMING_REQUEST: "@@Social/UPDATE_LIVESTREAMING_REQUEST",

    FETCH_MESSAGE_REQUEST: "@@Social/FETCH_MESSAGE_REQUEST",
    FETCH_MESSAGE_SUCCESS: "@@Social/FETCH_MESSAGE_SUCCESS",
    FETCH_MESSAGE_FAILURE: "@@Social/FETCH_MESSAGE_FAILURE",
    UPDATE_MESSAGE_INTERNAL: "@@Social/UPDATE_MESSAGE_INTERNAL",

    FETCH_MSG_USERS_REQUEST: "@@Social/FETCH_MSG_USERS_REQUEST",
    FETCH_MSG_USERS_SUCCESS: "@@Social/FETCH_MSG_USERS_SUCCESS",
    FETCH_MSG_USERS_FAILURE: "@@Social/FETCH_MSG_USERS_FAILURE",
};
